import React from 'react'
import { Inss } from './Inss'
import { Servidores } from './Servidores'
import { Default } from './Default'
import { Matricula } from 'models/meusDados/types'
import { CardBeneficio, SimpleTitleCardMeusDados } from './style'
import { capitalizeWords } from 'util/textFormatters'

import { FiGlobe } from 'react-icons/fi'

interface BeneficiosTabsProps {
  index: number
  matricula?: Matricula
}

const BeneficiosTabs = ({ matricula, index }: BeneficiosTabsProps) => {
  switch (matricula?.tipoPerfil) {
    case 1:
      return (
        <CardBeneficio className="my-2">
          <div className="alinhamento-beneficio">
            <SimpleTitleCardMeusDados>
              <FiGlobe className="icon" />{' '}
              {capitalizeWords(matricula?.descricaoPerfil ?? '')}
            </SimpleTitleCardMeusDados>

            <Inss index={index} />
          </div>
        </CardBeneficio>
      )
    case 4:
      return (
        <CardBeneficio className="my-2">
          <div className="alinhamento-beneficio">
            <SimpleTitleCardMeusDados>
              <FiGlobe className="icon" />{' '}
              {capitalizeWords(matricula?.descricaoPerfil ?? '')}
            </SimpleTitleCardMeusDados>
            <Servidores index={index} />
          </div>
        </CardBeneficio>
      )
    case 3:
      return (
        <CardBeneficio className="my-2">
          <div className="alinhamento-beneficio">
            <SimpleTitleCardMeusDados>
              <FiGlobe className="icon" />{' '}
              {capitalizeWords(matricula?.descricaoPerfil ?? '')}
            </SimpleTitleCardMeusDados>
            <Servidores index={index} />
          </div>
        </CardBeneficio>
      )
    case 5:
      return (
        <CardBeneficio className="my-2">
          <div className="alinhamento-beneficio">
            <SimpleTitleCardMeusDados>
              <FiGlobe className="icon" />{' '}
              {capitalizeWords(matricula?.descricaoPerfil ?? '')}
            </SimpleTitleCardMeusDados>
            <Servidores index={index} />
          </div>
        </CardBeneficio>
      )
    default:
      return (
        <CardBeneficio className="my-2">
          <div className="alinhamento-beneficio">
            <SimpleTitleCardMeusDados>
              <FiGlobe className="icon" />{' '}
              {capitalizeWords(matricula?.descricaoPerfil ?? '')}
            </SimpleTitleCardMeusDados>
            <Default index={index} />
          </div>
        </CardBeneficio>
      )
  }
}

export default BeneficiosTabs
